export const BASE_MAX_VALUE = 2048;